import { Select as AntSelect } from 'antd';
import styled from 'styled-components';
import React from 'react';
import { windowMaxWidth } from '../Layout/breakpoints';
import Spinner from '../Spinner/Spinner';
import IconCheck from '../Icons/IconCheck';

const StyledSelect = styled(AntSelect)`
  &.ant-select {
    width: 100%;

    .ant-select-suffix {
      inset-inline-end: 14px;
    }

    .ant-select-clear {
      align-items: center;
      display: flex;
      height: 20px;
      justify-content: center;
      position: absolute;
      top: 15px;
      right: 10px;
      width: 20px;
      background-color: var(--greyscale-dark-white);
    }

    .ant-select-placeholder {
      font-style: italic;
    }

    .ant-select-content {
      font-weight: var(--font-weight-regular);
    }

    &.ant-select-disabled {
      border: 1px solid var(--greyscale-dark-white);

      .ant-select-content {
        cursor: default;

        .ant-select-placeholder {
          color: var(--greyscale-concrete);
        }

        input {
          cursor: default;
        }
      }

      svg {
        path {
          stroke: var(--greyscale-concrete);
        }
      }
    }

    .ant-select-selection-item,
    .ant-select-content-value {
      font-size: ${(props) => (props.$fontSizeLarge ? 'var(--font-size-heading-3) !important' : '')};
      font-weight: ${(props) => (props.$fontSizeLarge ? 'var(--font-weight-medium) !important' : '')};

      .result {
        @media ${windowMaxWidth.mobile} {
          display: block !important;
          max-width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        span:not(.highlight):not(.non-highlight) {
          margin-left: 5px;
          width: 20px;
          display: inline-block;

          svg {
            position: absolute;
            top: 9px;

            circle,
            path {
              stroke: var(--primary-oqio-green);
              transition: all 0.2s ease-in-out;
            }

            &:hover {
              cursor: pointer;

              circle {
                fill: var(--primary-oqio-green);
                transition: all 0.2s ease-in-out;
              }

              path {
                stroke: var(--greyscale-white);
                transition: all 0.2s ease-in-out;
              }
            }
          }

          @media ${windowMaxWidth.mobile} {
            right: 20px;
            position: absolute;
          }
        }
      }
    }
  }

  &.tabs-navigation {
    display: none;
  }

  @media ${windowMaxWidth.mobile} {
    &.tabs-navigation {
      display: flex;
    }
  }
`;

const getCustomSuffixIcon = () => (
  <svg width="14" height="9" viewBox="0 0 14 9" fill="none">
    <path
      d="m 1.0316302,1.160584 6,5.9999997 5.9999988,-5.9999997"
      stroke="var(--greyscale-blackish)"
      strokeWidth="1.5"
      id="path2"
    />
  </svg>
);

const getDefaultNotFoundContent = (isSearchLoading, searchValue) => {
  if (isSearchLoading) {
    return <Spinner />;
  }

  return searchValue?.length > 0 ? 'Keine Ergebnisse gefunden' : false;
};

const getDefaultPlaceholder = (showSearch) => (showSearch ? 'Suchen' : 'Bitte wählen');

const StyledCheckmarkIcon = styled.span`
  svg path {
    stroke: var(--primary-oqio-blue);
  }
`;

const CheckmarkIconPlaceholder = styled.span`
  display: inline-block;
  width: 20px;
`;

const CheckmarkIcon = () => (
  <StyledCheckmarkIcon>
    <IconCheck />
  </StyledCheckmarkIcon>
);

const getMenuItemSelectedIcon = ({ isSelected }) => (isSelected ? <CheckmarkIcon /> : <CheckmarkIconPlaceholder />);

const ExtendedSelect = ({ showCheckmark = true, innerRef, isSearchLoading, ...props }) => {
  return (
    <StyledSelect
      placeholder={props.placeholder || getDefaultPlaceholder(props.showSearch)}
      suffixIcon={props.suffixIcon || getCustomSuffixIcon()}
      notFoundContent={props.notFoundContent || getDefaultNotFoundContent(isSearchLoading, props.searchValue)}
      menuItemSelectedIcon={showCheckmark ? getMenuItemSelectedIcon : null}
      styles={showCheckmark ? undefined : { option: { paddingInlineStart: 14 } }}
      {...props}
      ref={innerRef || undefined}
    />
  );
};

ExtendedSelect.Option = AntSelect.Option;

export default ExtendedSelect;
